import { DEFAULT_LOCALE, PUBLIC_APP_URL } from '~/core/constants/env'

import { format } from 'date-fns'
import type { CareerPageSettingType } from '../types'

export const getTitleOfMeta = ({
  jobTitle,
  jobLocations,
  companyName
}: {
  jobTitle: string
  jobLocations: string[]
  companyName: string
}) => {
  if (!jobTitle) return ''
  return `Hiring for ${jobTitle} ${
    jobLocations.length > 0 ? `for ${jobLocations.join(' ,')}` : ''
  } ${companyName ? `- ${companyName}` : ''}
  `
}

export const removeHTMLTags = (content: string): string => {
  return content.replace(/<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g, '')
}

export const combineDomainCareerPage = (careerSetting: CareerPageSettingType) => {
  const defaultLang = Object.keys(careerSetting?.languages || {}).find(
    (lang) => !!careerSetting.languages?.[lang]?.default
  )

  return `${PUBLIC_APP_URL}${defaultLang !== DEFAULT_LOCALE ? `/${defaultLang}` : ''}`
}

export const convertCanonicalToSlug = (value: string) =>
  value?.replace(/^\/(ja\/)?careers\//, '').replace(/\/$/, '')

export const formatTimeCountDownAIInterview = (totalSeconds: number): string => {
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  const pad = (n: number) => n.toString().padStart(2, '0')

  return hours > 0 ? `${hours}:${pad(minutes)}:${pad(seconds)}` : `${pad(minutes)}:${pad(seconds)}`
}

export function renderTimestampHHMM(dateInput: number) {
  const date = new Date(dateInput)
  if (isNaN(date.getTime())) return ''
  return format(date, 'HH:mm')
}
